// @ts-ignore
import Plotly from 'plotly.js-cartesian-dist';
import * as React from 'react';
import { PlotParams } from 'react-plotly.js';
import createPlotlyComponent from 'react-plotly.js/factory';

export const Plot: React.ComponentType<PlotParams> = createPlotlyComponent(Plotly);
